import React from 'react';
import { useTranslation } from 'react-i18next';

import { BusinessApp, FieldApp } from '@/modules/Onboarding';

import Phone from '~/images/shared/Phone.svg';

const ConnectEcoSystem = () => {
  const { t } = useTranslation('onboarding');

  return (
    <div className='h-fit w-full rounded-2xl bg-background-neutral-99 py-16 desktop:sticky desktop:top-77 desktop:w-1/3'>
      <div className='flex w-full items-center gap-16 border-b-xs border-b-neutralVariant-90 px-24 pb-16'>
        <span className='text-24 text-primary-default'>
          <Phone />
        </span>
        <span className='text-18 font-semi-bold'>{t('connect-ecosystem')}</span>
      </div>
      <BusinessApp flex='flex-col' />
      <div className='my-24 w-full border-b-xs border-b-neutralVariant-90'></div>
      <FieldApp flex='flex-col' />
    </div>
  );
};

export { ConnectEcoSystem };
